import { InputBase, InputBaseProps } from "@compass/core";
import { ModelPropertyBase, ModelPropertyType } from "generated/openApi";

export type InputProps = InputBaseProps & { modelProperty?: ModelPropertyBase | undefined };

export const Input = (props: InputProps) => {
  const { modelProperty, ...rest } = props;

  return (
    <InputBase
      label={props.modelProperty?.displayName}
      required={props.modelProperty?.required}
      maxLength={props.modelProperty?.maxLength}
      type={
        props.modelProperty?.type === ModelPropertyType.Int || props.modelProperty?.type === ModelPropertyType.Decimal
          ? "number"
          : undefined
      }
      {...rest}
    />
  );
};
